
import { defineComponent } from "vue";
import UserLoginSessions from "@/api/Security/UserLoginSessions";
export default defineComponent({
  name: "UserSessionHistory",
  props: ['record'],
  data() {
    return {
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "UserName", label: "Usuario", sortable: true },
          { key: "RoleAtLogin", label: "Rol", sortable: true },
          { key: "LoginDate", label: "Fecha de ingreso", sortable: true },
          { key: "LogoutDate", label: "Fecha de salida", sortable: true },
          { key: "ExpirationDate", label: "Expiración", sortable: true },
          { key: "IPAddress", label: "IP", sortable: true },
          { key: "Device", label: "Dispositivo", sortable: true },
          { key: "Location", label: "Ubicación", sortable: true },
          { key: "IsSuccessful", label: "Acceso concedido", sortable: true },
          { key: "LoginMethod", label: "Método", sortable: true },
          { key: "FailureReason", label: "Error", sortable: true },
          { key: "CreatedBy", label: "Creado por", sortable: true },
          { key: "CreatedDate", label: "Fecha creación", sortable: true }
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
          (item: any) =>
            item.UserName.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            ) ||
            item.Metodo.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            )
        )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      if (this.record.Id > 0)
        this.table.records = await UserLoginSessions.GetSystemUserLoginSessionsbyId(this.record.Id);
      this.table.loading = false;
    },

  },
});
